"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgHouseOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 1.64L2.32 14.27l1.36 1.46L6 13.59V28h20V13.59l2.32 2.14 1.36-1.46zM14 26v-7.4a5 5 0 014 0V26zm10 0h-4v-8.52l-.43-.3a6.87 6.87 0 00-7.14 0l-.43.3V26H8V11.75l8-7.39 8 7.39z" })));
}
exports.default = SvgHouseOutline;
//# sourceMappingURL=HouseOutline.js.map